// extracted by mini-css-extract-plugin
export default {"Container":"BannerSelector_Container__BnNJo","Selection":"BannerSelector_Selection__QciY7"};